var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smart-select',{attrs:{"value":_vm.value,"items":_vm.sourceItems,"item-text":_vm.sourceItemText,"item-value":_vm.sourceItemValue,"label":_vm.label,"loading":_vm.sourceLoading,"disabled":_vm.readonly},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }